import type { MonthlyNetSalesReportDto } from './MonthlyNetSalesReportDto';
import type { MonthlyNetSalesReport } from 'model/MonthlyNetSalesReport';

export const convertToMonthlyNetSalesReport = (dto: MonthlyNetSalesReportDto): MonthlyNetSalesReport => {
    return {
        year: Number(dto.year),
        range: dto.range,
        refunds: {
            byMonth: (dto.refunds?.by_month ?? []).map(item => ({
                month: Number(item.month),
                amount: Number(item.amount ?? 0)
            })),
            yearTotal: Number(dto.refunds?.year_total ?? 0)
        },
        rows: (dto.rows ?? []).map(row => ({
            key: row.key,
            label: row.label,
            months: (row.months ?? []).map(item => ({
                month: Number(item.month),
                netSales: Number(item.net_sales ?? 0)
            })),
            yearTotal: Number(row.year_total ?? 0),
            pct: Number(row.pct ?? 0)
        }))
    };
};
